import connectQueryRules from "instantsearch.js/es/connectors/query-rules/connectQueryRules.js";
import { useConnector } from "../hooks/useConnector.js";
export function useQueryRules(props, additionalWidgetProperties) {
  return useConnector(connectQueryRules, props, additionalWidgetProperties);
}